module.exports = __webpack_public_path__ + "static/media/Silver-Pinot-Noir-Rose.d7da2411.jpg";